import React from "react";

import { Button, Input, Typography } from "clearsense-ui/components";

const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  handleSubmit,
  loading,
  setIsReset,
}) => (
  <>
    <Typography
      style="xLarge"
      className="mb-5 text-xl font-normal text-left text-gray-800"
      data-cy="sign-in-header"
    >
      Log in to your Clearsense account
    </Typography>
    <form onSubmit={e => e.preventDefault()} className="space-y-6">
      <Input
        required
        label="Email"
        type="email"
        value={email}
        placeholder="oliver@example.com"
        data-cy="login-email-text-field"
        onChange={e => setEmail(e.target.value)}
      />
      <Input
        required
        label="Password"
        type="password"
        value={password}
        placeholder="******"
        data-cy="login-password-text-field"
        onChange={e => setPassword(e.target.value)}
      />
      <div className="flex justify-end w-full">
        <Button
          style="text"
          label="Forgot your Password?"
          size="small"
          className="text-xs text-indigo-700"
          onClick={() => setIsReset(true)}
          data-cy="forgot-password-link"
        />
      </div>
      <Button
        fullWidth
        type="submit"
        label="Login"
        data-cy="login-submit-button"
        className="h-8 mt-4"
        onClick={handleSubmit}
        loading={loading}
      />
    </form>
  </>
);

export default LoginForm;
